{
  "backToDevices": "Back to Devices",
  "connectionsTitle": "Connections",
  "currentStatusTitle": "Current Status",
  "deviceInfoTitle": "Device Info",
  "helpBody": "The device profile allows you to manage individual devices. You can change a device's configuration, view its history of updates it has given and actions it has executed, and more.",
  "deviceIsNotCenterPivot": "This feature is only available for devices that are configured as center pivots.",
  "deviceLocationNotAvailable": "Device location not available",
  "deviceNotFoundWithCodaDeviceAlias": "No device with alias {{codaDeviceAlias}} found.",
  "linkToActionHistory": "Commands",
  "linkToConfiguration": "Configuration",
  "linkToEventHistory": "History",
  "linkToLanding": "Home",
  "linkToNotifications": "Notifications",
  "locationTitle": "Location",
  "noWarnings": "No warnings found for this device.",
  "note": "Note",
  "title": "Device Profile",
  "warningsTitle": "Warnings"
}
